import { computed } from "@preact/signals";
import { counter } from "@components/WalletForm/models/counter.ts";
import {
  currentPrice,
  getFormattedPrice,
} from "@components/WalletForm/models/products";
import { accessoryQuantity, accessoryPrice } from "./accessory";

export const total = computed(() => counter.value * (currentPrice.value ?? 0) + accessoryQuantity.value * accessoryPrice.peek());
export const totalFormatted = computed(() => getFormattedPrice(total));
